export default function skeletonLoader() {
    document.addEventListener("DOMContentLoaded", () => {
        const courtsContainer = document.querySelector(".courts__items");
        const tempoDeLoading = 2000;

        setTimeout(() => {
            if (courtsContainer) {
                courtsContainer.classList.remove("loading");
                console.log("Loading finalizado. Exibindo o slider.");
            }
        }, tempoDeLoading);
    });
}